export default __webpack_public_path__ + "static/media/learn3.217f72b6.jpg";